module.exports = __webpack_public_path__ + "static/media/kevin-kull-edited2.3541bd0f.png";